module.exports = __webpack_public_path__ + "img/logotype.687ae45d.png";